import { Link } from "react-router";
import { useAppContext } from "@/providers";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "light" | "dark" | "color";
}

const sizeClasses = {
  sm: "w-24 h-8",
  md: "w-32 h-10",
  lg: "w-40 h-12",
};

export function Logo({ className = "", size = "md" }: LogoProps) {
  const { locale } = useAppContext();
  const logoSrc =
    locale === "ar" ? "/images/Logo%20ar.png" : "/images/Logo%20h.png";

  return (
    <Link to="/" className={`block relative ${className}`}>
      <div className={`relative ${sizeClasses[size]}`}>
        <img
          src={logoSrc}
          alt={locale === "ar" ? "شعار أثر" : "Athr Logo"}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          loading="eager"
        />
      </div>
    </Link>
  );
}
